import React, { useState, useEffect, useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import EmployeeForm from './EmployeeForm';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';

const Employee = ({ nameSingle, namePlural, separator }) => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [reload, setReload] = useState(true);
  const [rows, setRows] = useState([]);
  const [loadSubmit, setLoadSubmit] = useState(false);
  const [dataUpdated, setDataUpdated] = useState({});
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [loadSubmitDelete, setLoadSubmitDelete] = useState(false);
  const [dataDeleted, setDataDeleted] = useState({});

  useEffect(() => {
    if (reload) {
      setIsProcessing(true);
      Controllers.employee.get_employee().then(res => {
        setRows(res.data);
      }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
          setIsProcessing(false);
          setReload(false);
        });
    }
  }, [reload]);

  const handleInsertUpdate = ({ data }) => {
    setLoadSubmit(true);
    Controllers.employee.employee_insert_update(data).then(res => {
      Helpers.toast.construct({ ...res, toast });
      if (res.response === 'success') {
        setModalShow(false);
        setDataUpdated({});
      }
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setLoadSubmit(false);
        setReload(true);
      });
  };

  const handleGet = e => {
    let $this = e.currentTarget;

    if (!$this.dataset?.idEmployee) {
      setModalTitle(`Registrar ${nameSingle}`);
      setDataUpdated({});
      setModalShow(true);
      return;
    }

    let buttonHTML = $this.innerHTML;
    $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>';
    let { idEmployee } = $this.dataset;

    Controllers.employee.get_employee_id({ p_id_employee: idEmployee }).then(res => {
      setModalTitle(`Modificar ${nameSingle} #${idEmployee}`);
      setDataUpdated({ data: res.data });
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toast });
      setReload(true);
    })
      .finally(() => $this.innerHTML = buttonHTML);
  };

  const handleDelete = () => {
    setLoadSubmitDelete(true);

    Controllers.employee.employee_delete(dataDeleted).then(res => {
      Helpers.toast.construct({ ...res, toast });
      if (res.response === 'success') {
        setShowConfirmDelete(false);
        setDataDeleted({});
      }
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setReload(true);
        setLoadSubmitDelete(false);
      });
  };

  const handleHideModalForm = () => {
    setModalShow(false);
    setLoadSubmit(false);
  };

  const handleShowModalDelete = e => {
    let { idEmployee, nameEmployee } = e.currentTarget.dataset;
    setDataDeleted({
      p_id_employee: idEmployee,
      p_name_employee: nameEmployee
    });
    setShowConfirmDelete(true);
  };

  const handleHideModalDelete = () => setShowConfirmDelete(false);

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[
      [
        { name: 'id_employee', text: 'ID', align: 'center' },
        { name: 'name_employee', text: 'Nombres' },
        { name: 'last_name_employee', text: 'Apellidos' },
        { name: 'rfc_employee', text: 'RFC', align: 'center' },
        {
          name: 'enabled_employee', text: 'Estado', align: 'center', render: r => <div className={'badge badge-' + (parseInt(r.enabled_employee) === 1 ? 'success' : 'danger')}>
            {parseInt(r.enabled_employee) === 1 ? 'Activo' : 'Inactivo'}
          </div>
        },
        {
          name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
            return <div>
              <Button variant="info" className="mr-1" size="xs" data-id-employee={u.id_employee} onClick={handleGet}>
                <i className="fa fa-edit"></i>
              </Button>
              <Button variant="danger" size="xs" data-id-employee={u.id_employee} data-name-employee={u.name_employee} onClick={handleShowModalDelete}>
                <i className="fa fa-trash"></i>
              </Button>
            </div>;
          }
        },
      ],
    ]}
    rows={rows}
    isProcessing={isProcessing}
  />, [rows, isProcessing]);

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De {namePlural}</span>
        <Button size="sm" onClick={handleGet}>
          <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
        </Button>
      </Card.Header>
      <Card.Body>
        {dtRows}
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EmployeeForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
      </Modal.Body>
    </Modal>
    <SweetAlert
      icon="delete"
      show={showConfirmDelete}
      showCancelButton
      title={<>¿Desea eliminar {separator} {nameSingle}?</>}
      subtitle={<>#{dataDeleted.p_id_employee} - {dataDeleted.p_name_employee}</>}
      confirmButtonText="¡Sí, eliminar!"
      cancelButtonText="¡No!"
      loadSubmit={loadSubmitDelete}
      onCancel={handleHideModalDelete}
      onConfirm={handleDelete}
    />
  </>;
};

export default Employee;
